<template>
  <div class="cfp">
    <v-container class="my-5">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="ma-3">
            <!-- <v-card-title class="accent secondary--text">CFP Teams</v-card-title> -->
            <v-card-text class="mt-5">
                <h2 class="font-weight-bold mb-2">CFP Teams</h2>
              <v-divider class="mb-6"/>
              <v-form ref="cfpTeamsForm">
                <v-autocomplete
                  chips
                  :search-input.sync="search"
                  hide-selected
                  v-model="cfpPicks.teams"
                  :items="displayTeams"
                  label="Select 4 teams"
                  item-text="school"
                  item-value="school"
                  multiple
                  @change="updateCfpPicks()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No results matching "
                          <strong>{{ search }}</strong>". Press
                          <kbd>enter</kbd>
                          to add {{search}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 v-if="cfpPicks.teams && cfpPicks.teams.length === 4">
          <v-card class="ma-3">
            <!-- <v-card-title class="accent secondary--text">CFP National Champion</v-card-title> -->
            <v-card-text class="mt-5">
                <h2 class="font-weight-bold mb-2">CFP National Champion</h2>
              <v-divider class="mb-6"/>
              <v-radio-group v-model="cfpPicks.winner">
                <v-radio
                  color="error"
                  v-for="n in cfpPicks.teams"
                  :key="n"
                  :label="`${n}`"
                  :value="n"
                  @change="updateCfpPicks(n)"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "CFP",
  data() {
    return {
      max: 4,
      search: null
    };
  },
  methods: {
      updateCfpPicks(team){
          this.cfpPicks.winner = team
          this.$store.dispatch('updateCfpPicks', this.cfpPicks)
      }
  },
  computed: {
    ...mapState(["allTeams"]),
    ...mapGetters(["cfpPicks"]),
    displayTeams() {
      return this.allTeams.filter(
        x =>
          x.conference === "SEC" ||
          x.conference === "ACC" ||
          //x.conference === "Big Ten" ||
          //x.conference === "Pac-12" ||
          x.conference === "Big 12" ||
          x.conference === "FBS Independents" ||
          x.conference === "American Athletic" ||
          x.conference === "Mountain West"
      );
    }
  },
  watch: {
      'cfpPicks.teams'(val) {
        if (val && val.length > 4) {
          this.$nextTick(() => this.cfpPicks.teams.pop());
        }
      }
  },
  created() {
    this.$store.dispatch("fetchCfpPicks")
  }
};
</script>